// pages/auth/ForgotPassword.tsx
import React from "react";
import { Helmet } from "react-helmet-async";
import logo from "../../assets/swyvery-logo-login.png";
import EmailForm from "../../components/ForgotPassword/EmailForm";
import NewPassword from "../../components/ForgotPassword/NewPassword";
import OTPForm from "../../components/ForgotPassword/OtpForm";
import useForgotPassword from '../../hooks/logics/auth/use-forget-password';

const ForgotPassword = () => {
  const {
    currentStep,
    isResendDisabled,
    countdown,
    resendAttempts,
    step1Form,
    step2Form,
    step3Form,
    handleResendOtp,
  } = useForgotPassword();

  return (
    <>
      <Helmet>
        <title>Forgot password - Swyvery admin</title>
      </Helmet>
      <div className="w-full bg-gray-100 h-screen flex flex-col items-center justify-center">
        <img src={logo} alt="Swyvery Logo" />
        {currentStep === 1 ? (
          <EmailForm step1Form={step1Form} />
        ) : currentStep === 2 ? (
          <OTPForm
            isResendDisabled={isResendDisabled}
            onResend={handleResendOtp}
            countDown={countdown}
            resendAttempts={resendAttempts}
            step2Form={step2Form}
          />
        ) : currentStep === 3 ? (
          <NewPassword step3Form={step3Form} />
        ) : null}
      </div>
    </>
  );
};

export default ForgotPassword;